import { useCalendar } from "@modules/calendar/hooks/useCalendar"
import { word } from "@modules/core/utils/i18n"
import { ProgramHeaderActionsView } from "@modules/programs/components/programHeader/programHeaderActionsView"
import { useProgramRights } from "@modules/programs/hooks/useProgramRights"
import { ProgramInfinite } from "@modules/programs/programInfiniteTypes"
import { ProgramOnOff } from "@modules/programs/programOnOffTypes"
import { HUSwitch } from "@modules/ui/components/huSwitch"
import { HUText } from "@modules/ui/components/huText"

type ProgramHeaderRightViewProps = {
  program?: ProgramInfinite | ProgramOnOff
}

export const ProgramHeaderRightView: React.FC<ProgramHeaderRightViewProps> = ({ program }) => {
  const { displayDetailedEvents, setDisplayDetailedEvents } = useCalendar()
  const { isAuthor, isAcceptedSharedCoach } = useProgramRights(program)

  const canSeeActions = (isAuthor || isAcceptedSharedCoach) && program

  return (
    <div className="flex flex-column align-items-center justify-content-between h-full p-0 gap-3">
      {canSeeActions && <ProgramHeaderActionsView program={program} />}

      <div
        className={
          "card my-0 py-4 flex flex-column align-items-center justify-content-evenly w-full " +
          (!canSeeActions && "rounded-33 flex-1")
        }
      >
        <div className="flex flex-row gap-2 justify-content-center align-items-center text-center p-0">
          <HUText className="p-0 max-w-4rem" fontStyle="LM">
            {word("program.planning.view.global")}
          </HUText>
          <HUSwitch
            style={{ minWidth: "3rem" }}
            className="m-0"
            name={"Switch"}
            type={"switch"}
            checked={displayDetailedEvents}
            onChange={() => setDisplayDetailedEvents(!displayDetailedEvents)}
          />
          <HUText className="p-0 max-w-4rem" fontStyle="LM">
            {word("program.planning.view.detailed")}
          </HUText>
        </div>
      </div>
    </div>
  )
}
